import styled from 'styled-components';
import SwipeableViews from 'react-swipeable-views';

export const StyledSwipeableViews = styled(SwipeableViews)``;
